import { render } from "./EventDetailsContainer.vue?vue&type=template&id=5ecb6c66&scoped=true"
import script from "./EventDetailsContainer.vue?vue&type=script&lang=js"
export * from "./EventDetailsContainer.vue?vue&type=script&lang=js"

import "./EventDetailsContainer.vue?vue&type=style&index=0&id=5ecb6c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecb6c66"]])

export default __exports__